var React = require('react');

function BlogIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"17.1111","height":"21","transform":"matrix(1 0 0 -1 0.285156 22)","fill":"#1ECFD3","key":0}),React.createElement("path",{"d":"M10.2198 16.8066L6.44741 17.5871L7.22791 13.8147L19.3256 1.71703L22.3174 4.70892L10.2198 16.8066Z","fill":"#6297FF","key":1}),React.createElement("path",{"d":"M23.2397 4.03259L21.7438 2.53665L20.2479 1.0407C20.8226 0.465962 21.7544 0.465962 22.3292 1.0407L23.2397 1.95128C23.8145 2.52602 23.8145 3.45785 23.2397 4.03259Z","fill":"#6297FF","key":2})]);
}

BlogIcon.defaultProps = {"width":"25","height":"22","viewBox":"0 0 25 22","fill":"none"};

module.exports = BlogIcon;

BlogIcon.default = BlogIcon;
